module.exports = {
      id: "sri-lanka-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#sri-lanka-flag",
      toString: function () {
        return this.url;
      }
    }